const API_TOKEN_NAME = process.env.VUE_APP_ENV_COMPANY_NAME + '-api-token'
export default {
    state: {
        token: sessionStorage.getItem(API_TOKEN_NAME) === 'null' ? null : sessionStorage.getItem(API_TOKEN_NAME),
        drawer: sessionStorage.getItem('drawer') === 'false',
        refreshToken: sessionStorage.getItem(API_TOKEN_NAME + '-refreshToken'),
        refreshTokenExpiration: sessionStorage.getItem('secunet-refreshTokenExpiration'),
        myAssignmentsEnabled: sessionStorage.getItem('my-assignments-enabled') === 'true',
        userId: sessionStorage.getItem('user-id'),
        userContractor: sessionStorage.getItem('user-contractor'),
        assignmentViewPreference: sessionStorage.getItem('assignment-view-preference'),
        theming: sessionStorage.getItem('theming'),
        config: sessionStorage.getItem('config') ? JSON.parse(sessionStorage.getItem('config')) : {}
    },
    mutations: {
        setToken(state, value) {
            state.token = value
        },
        setDrawer(state, value) {
            state.drawer = value
        },
        setRefreshToken(state, value) {
            state.refreshToken = value
        },
        setRefreshTokenExpiration(state, value) {
            state.refreshTokenExpiration = value
        },
        setMyAssignmentsEnabled(state, value) {
            state.myAssignmentsEnabled = value
        },
        setUserId(state, value) {
            state.userId = value
        },
        setUserContractor(state, value) {
            state.userContractor = value
        },
        setAssignmentViewPreference(state, value) {
            state.assignmentViewPreference = value
        },
        setTheming(state, value) {
            state.theming = value
        },
        setConfig(state, value) {
            state.config = value
        }
    },
    actions: {
        logout({ dispatch }) {
            dispatch('setConfig', null)
            dispatch('setTheming', null)
            dispatch('setToken', null)
            dispatch('setDrawer', null)
            dispatch('setUserId', null)
            dispatch('setUserContractor', null)
            dispatch('setRefreshToken', null)
            dispatch('setRefreshTokenExpiration', null)
            dispatch('setMyAssignmentsEnabled', null)
            dispatch('setAssignmentViewPreference', null)
            sessionStorage.clear()
        },
        login({ dispatch }, [resp]) {
            if (resp.data.token) {
                dispatch('setMyAssignmentsEnabled', false)
                dispatch('setToken', resp.data.token)
                dispatch('setDrawer', true)
                dispatch('setUserId', resp.data.userId)
                dispatch('setUserContractor', resp.data.userContractor)
                dispatch('setRefreshToken', resp.data.refreshToken)
                dispatch('setRefreshTokenExpiration', resp.data.refreshTokenExpiration)
                dispatch('setAssignmentViewPreference', 'cards')
            }
        },
        setUserId({ commit }, userId) {
            sessionStorage.setItem('user-id', userId)
            commit('setUserId', userId)
        },
        setUserContractor({ commit }, userContractor) {
            sessionStorage.setItem('user-contractor', userContractor)
            commit('setUserContractor', userContractor)
        },
        setTheming({ commit }, theming) {
            sessionStorage.setItem('theming', theming)
            commit('setTheming', theming)
        },
        setConfig({ commit }, config) {
            sessionStorage.setItem('config', JSON.stringify(config))
            commit('setConfig', config)
        },
        setToken({ commit }, token) {
            sessionStorage.setItem(API_TOKEN_NAME, token)
            commit('setToken', token)
        },
        setAssignmentViewPreference({ commit }, preference) {
            sessionStorage.setItem('assignment-view-preference', preference)
            commit('setAssignmentViewPreference', preference)
        },
        setMyAssignmentsEnabled({ commit }, myAssignmentsEnabled) {
            sessionStorage.setItem('my-assignments-enabled', myAssignmentsEnabled)
            commit('setMyAssignmentsEnabled', myAssignmentsEnabled)
        },
        setDrawer({ commit }, drawer) {
            sessionStorage.setItem('drawer', drawer)
            commit('setDrawer', drawer)
        },
        setRefreshToken({ commit }, refreshToken) {
            if (refreshToken) {
                sessionStorage.setItem('secunet-refreshToken', refreshToken)
                commit('setRefreshToken', refreshToken)
            } else {
                sessionStorage.removeItem('refreshToken')
                commit('setRefreshToken', null)
            }
        },
        setRefreshTokenExpiration({ commit }, refreshTokenExpiration) {
            if (refreshTokenExpiration) {
                sessionStorage.setItem('secunet-refreshTokenExpiration', refreshTokenExpiration)
                commit('setRefreshTokenExpiration', refreshTokenExpiration)
            } else {
                sessionStorage.removeItem('secunet-refreshTokenExpiration')
                commit('setRefreshTokenExpiration', null)
            }
        }
    },
    getters: {
        getConfig: state => state.config,
        getToken: state => state.token,
        isLoggedIn(state) {
            // is string null because of local storage
            return state.token !== null
        },
        getDrawer: state => state.drawer,
        getRefreshToken: state => state.refreshToken,
        getRefreshTokenExpiration: state => state.refreshTokenExpiration,
        getMyAssignmentsEnabled: state => state.myAssignmentsEnabled,
        getUserId: state => state.userId,
        getUserContractor: state => state.userContractor,
        getAssignmentViewPreference: state => state.assignmentViewPreference,
        getTheming: state => JSON.parse(state.theming)
    }
}
